import { render } from "./StoreIcon.vue?vue&type=template&id=7024b248"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/StoreIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7024b248"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7024b248', __exports__)) {
    api.reload('7024b248', __exports__)
  }
  
  module.hot.accept("./StoreIcon.vue?vue&type=template&id=7024b248", () => {
    api.rerender('7024b248', render)
  })

}


export default __exports__